<template>
 <div>
   <div v-if="isLoading">
     <div id="jFormSpinnerOverlay" style=""><!----></div>
     <div id="jFormSpinner" style="">
       <div class="spinner" role="progressbar" style="position: absolute; width: 0px; z-index: 2000000000; left: 50%; top: 30px;">
         <img src="../assets/images/Spinner-1s-88px.gif" alt="Attendez svp..." />
       </div>
       <span id="jFormSpinnerOpts" style="display:none"><!----></span><div class="message" role="alert" tabindex="1"><p>Attendez svp...</p> </div></div>
   </div>
 </div>
</template>

<script>
export default {
  name: 'loading',
  props: ['isLoading'],
};
</script>

<style>
  #jFormSpinnerOverlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background: #ffffff;
    opacity: 0.7;
  }

  #jFormSpinner {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto;
    padding: 8px;
    vertical-align: middle;
    width: 150px;
    height: 110px;
    z-index: 1001;
    background: #ffffff;
    border-radius: 3px;
    display: block;
    border: 1px solid #e1e1e1;
  }

  #jFormSpinner #jFormSpinnerOpts {
    top: 30px;
    color: #0092d0;
  }

  #jFormSpinner .message {
    position: absolute;
    left: 0;
    bottom: 20px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: inherit;
  }

  #jFormSpinner .message p {
    margin: 0;
  }

  .spinner  img{
    display: block;
    position:   absolute;
    top: -40px;
    left: -44px;
  }

</style>
